import React, { memo, ReactElement } from "react";

function ExclamationSvgImage(props: { className?: string }): ReactElement {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 82 82" className={props.className}>
            <path
                fill="#D07D00"
                stroke="#D07D00"
                d="M80.65 41a39.6 39.6 0 0 1-39.54 39.65A39.6 39.6 0 0 1 1.58 41 39.6 39.6 0 0 1 41.1 1.35 39.6 39.6 0 0 1 80.65 41Z"
                opacity=".8"
            />
            <path
                fill="#fff"
                d="M41 49.23a4.58 4.58 0 0 1 4.56 4.62A4.58 4.58 0 0 1 41 58.46a4.58 4.58 0 0 1-4.56-4.61A4.58 4.58 0 0 1 41 49.23Zm-1.42-27.21h2.84c1.46 0 2.64 1.2 2.64 2.68v18.08a2.66 2.66 0 0 1-2.64 2.68h-2.84a2.66 2.66 0 0 1-2.64-2.68V24.7a2.66 2.66 0 0 1 2.64-2.68Z"
            />
        </svg>
    );
}

export default memo(ExclamationSvgImage);
